import { ErrorBase } from './ErrorBase';

export class ValidationError extends ErrorBase {
  constructor({ message, cause }: { message: string; cause: Error }) {
    super({ message, cause });
    this.name = 'ValidationError';
  }
}
